import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cities } from "./registrationData";

interface RegistrationFieldsProps {
  formData: {
    parentName: string;
    parentMobile: string;
    email: string;
    childName: string;
    childAge: string;
    city: string;
  };
  handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setFormData: React.Dispatch<React.SetStateAction<{
    parentName: string;
    parentMobile: string;
    email: string;
    childName: string;
    childAge: string;
    city: string;
  }>>;
}

export const RegistrationFields = ({ formData, handleChange, setFormData }: RegistrationFieldsProps) => {
  return (
    <div className="w-full max-w-4xl mx-auto px-4 sm:px-6 space-y-6">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="parentName" className="text-sm font-medium">
            Parent's Name *
          </Label>
          <Input
            id="parentName"
            name="parentName"
            required
            value={formData.parentName}
            onChange={handleChange}
            className="w-full rounded-xl border-purple-100 focus:border-primary focus:ring-primary"
            placeholder="Enter parent's name"
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="parentMobile" className="text-sm font-medium">
            Mobile Number *
          </Label>
          <Input
            id="parentMobile"
            name="parentMobile"
            type="tel"
            required
            value={formData.parentMobile}
            onChange={handleChange}
            className="w-full rounded-xl border-purple-100 focus:border-primary focus:ring-primary"
            placeholder="Enter mobile number"
            pattern="[0-9]{10}"
            maxLength={10}
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="email" className="text-sm font-medium">
          Email Address *
        </Label>
        <Input
          id="email"
          name="email"
          type="email"
          required
          value={formData.email}
          onChange={handleChange}
          className="w-full rounded-xl border-purple-100 focus:border-primary focus:ring-primary"
          placeholder="Enter email address"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="childName" className="text-sm font-medium">
            Child's Name *
          </Label>
          <Input
            id="childName"
            name="childName"
            required
            value={formData.childName}
            onChange={handleChange}
            className="w-full rounded-xl border-purple-100 focus:border-primary focus:ring-primary"
            placeholder="Enter child's name"
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="childAge" className="text-sm font-medium">
            Child's Age *
          </Label>
          <Input
            id="childAge"
            name="childAge"
            type="number"
            min="1"
            max="18"
            required
            value={formData.childAge}
            onChange={handleChange}
            className="w-full rounded-xl border-purple-100 focus:border-primary focus:ring-primary"
            placeholder="Enter age"
          />
        </div>
      </div>

      <div className="space-y-2">
        <Label htmlFor="city" className="text-sm font-medium">
          Select Center *
        </Label>
        <Select
          value={formData.city}
          onValueChange={(value) => setFormData({ ...formData, city: value })}
        >
          <SelectTrigger className="w-full rounded-xl border-purple-100 focus:border-primary focus:ring-primary">
            <SelectValue placeholder="Choose your nearest center" />
          </SelectTrigger>
          <SelectContent className="max-h-[300px] overflow-y-auto">
            {cities.map((city) => (
              <SelectItem key={city} value={city}>
                {city}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};